"use client";
import { createContext, useContext, useState } from "react";

export const CompanyContext = createContext({
  companyFilters: {
    district: {
      id: 0,
      title: "",
    },
    service: {
      id: 0,
      title: "",
    },
  },
  setCompanyFilters: (bn: any) => { },
});

interface Props {
  children: React.ReactNode;
  serviceData: any;
  districtData: any;
}

export const CompanyProvider = ({ children, serviceData, districtData }: Props) => {
  const [companyFilters, setCompanyFilters] = useState({
    service: {
      id: serviceData?.id,
      title: serviceData?.descriptions?.[0]?.title,
    },
    district: {
      id: districtData?.id,
      title: districtData?.title,
    }
  } as any);

  const value = {
    companyFilters,
    setCompanyFilters,
  };

  return (
    <CompanyContext.Provider value={value}>{children}</CompanyContext.Provider>
  );
};

export const useCompanyContext = () => {
  return useContext(CompanyContext);
};
